import { Component, Vue } from 'vue-property-decorator';
import { SUPPORTED_LANGUAGES } from '@/config/app.config';

@Component
export default class LanguagePicker extends Vue {
  private languages = SUPPORTED_LANGUAGES;

  protected changeLocale(lang: string): void {
    this.$i18n.locale = lang;
    if (this.$store.state.isAuthenticated && this.$store.state.isDossierOpened) {
      this.$store.commit('setEquestLng', lang);
    }
  }

  protected isCurrentLanguage(lang: string): boolean {
    if (this.languages.includes(this.$i18n.locale)) {
      return this.$i18n.locale === lang;
    }
    return this.$i18n.fallbackLocale === lang;
  }
}
